<template>
  <div
    class="py-4 container-fluid faq-page-container"
    :class="{ 'faq-page-dark': isDarkMode }"
    :style="isDarkMode
      ? 'background: #1E293B !important; min-height: 100vh; max-width: none;'
      : 'max-width: none;'"
  >
    
    <div
      class="faq-hero-banner mb-3"
      :style="isDarkMode
        ? 'background: #0F172A !important; border: 1px solid #334155 !important; box-shadow: none !important; color: #E2E8F0 !important; border-radius: 0.65rem !important;'
        : 'border-radius: 0.65rem !important;'"
    >
      <div class="banner-content">
        <h1
          :style="isDarkMode
            ? 'color: #FF8A4C !important; font-weight: 800 !important; font-size: 1.5rem !important; letter-spacing: -0.02em;'
            : 'font-weight: 800 !important; font-size: 1.5rem !important; letter-spacing: -0.02em;'"
        >Centrum nápovědy & FAQ</h1>
        <p :style="isDarkMode ? 'color: #CBD5E1 !important; opacity: 1;' : ''">Hledáš odpověď? Vyber si kategorii níže nebo se podívej na nejčastější dotazy.</p>
      </div>
    </div>

    <div class="row">
      
      <div class="col-12 col-md-4 col-xl-3 mb-4">
        <div
          class="category-sidebar"
          :style="isDarkMode
            ? 'background: #0F172A !important; border: 1px solid #334155 !important; box-shadow: none !important;'
            : ''"
        >
          <div class="sidebar-title" :style="isDarkMode ? 'color: #94A3B8 !important;' : ''">Kategorie témat</div>
          <div class="category-menu">
            <button 
              v-for="(data, index) in FAQData" 
              :key="data.Ctg"
              class="category-link"
              :class="{ 'active-category': activeTab === index }"
              @click="activeTab = index"
            >
              <span
                class="category-icon"
                :style="isDarkMode && activeTab !== index ? 'background: #1E293B !important; color: #CBD5E1 !important;' : ''"
              >
                <i :class="categoryIcon(data)"></i>
              </span>
              <span
                class="category-text"
                :style="isDarkMode && activeTab !== index ? 'color: #E2E8F0 !important;' : ''"
              >{{ data.Ctg }}</span>
              <i class="pi pi-chevron-right arrow-indicator"></i>
            </button>
          </div>
        </div>

        <div
          class="border-0 shadow-sm rounded-4 text-center img-inga-card position-relative"
          :class="isDarkMode ? 'p-0' : 'p-3'"
          :style="isDarkMode
            ? 'background: #0F172A !important; border: none !important; box-shadow: none !important; border-radius: 0.65rem !important; margin-top: 5.5rem;'
            : 'background: #ffffff !important; border: 1px solid #e5e5e7; border-radius: 0.65rem !important; margin-top: 5.5rem;'"
        >
          <div
            class="inga-speech-bubble"
            :class="{ 'inga-speech-bubble-dark': isDarkMode }"
          >
            Než mě budeš kontaktovat, přečti si nejdřív nápovědu. Třeba tu odpověď už máme! 🦥
          </div>
          <IngaPortrait :src="imgRoot + 'inga.jpg'" />
        </div>
      </div>

      <div class="col-12 col-md-8 col-xl-9">
        <div
          class="faq-content-card shadow-sm border-0"
          :class="{ 'card': !isDarkMode }"
          :style="isDarkMode
            ? 'background: #0F172A !important; border: 1px solid #334155 !important; border-radius: 0.65rem !important;'
            : ''"
        >
          <div class="p-4">
            
            <div v-if="FAQData[activeTab]" class="current-category-header mb-4">
              <h2 :style="isDarkMode ? 'color: #E2E8F0 !important;' : ''">{{ FAQData[activeTab].Ctg }}</h2>
              <span class="badge-count" :style="isDarkMode ? 'background: #1E293B !important; color: #94A3B8 !important;' : ''">{{ FAQData[activeTab].FAQ.length }} dotazů</span>
            </div>

            <Accordion v-if="FAQData[activeTab]" class="custom-accordion" :multiple="false">
              <AccordionTab v-for="(FAQ, index) in FAQData[activeTab].FAQ" :key="index" :header="FAQ.Qst">
                <div class="faq-answer-wrapper">
                  <p class="faq-answer-text" :style="isDarkMode ? 'color: #CBD5E1 !important;' : ''" v-html="FAQ.Ans"></p>
                </div>
              </AccordionTab>
            </Accordion>

          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import dataService from "@/services/dataService";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import IngaPortrait from "./components/custom/IngaPortrait.vue";
import "primeicons/primeicons.css";

const store = useStore();
const isDarkMode = computed(() => !!store.state.isDarkMode);
const imgRoot = computed(() => process.env.VUE_APP_IMG_ROOT);
const FAQData = ref([]);
const activeTab = ref(0);

const fetchFAQData = async () => {
  FAQData.value = await dataService.GetFAQ();
};

const categoryIcon = (data) => {
  const raw = String(data?.Cic || data?.FAQ?.[0]?.Cic || "").trim();
  if (!raw) return "pi pi-book";
  if (raw.includes(" ")) return raw;
  if (raw.startsWith("pi-")) return `pi ${raw}`;
  if (raw.startsWith("bi-")) return `bi ${raw}`;
  return raw;
};

fetchFAQData();
</script>

<style scoped>
/* ==========================================
   GLOBÁLNÍ NASTAVENÍ A BANNER
   ========================================== */
.faq-page-container {
  font-family: 'Ubuntu Sans', Ubuntu, sans-serif;
  max-width: none;
  width: 100%;
}

.faq-hero-banner {
  background: linear-gradient(135deg, #FFE8D6 0%, #FFD6BB 100%);
  border: 1px solid #FEC88F;
  border-radius: 0.65rem;
  padding: 16px 24px;
  color: #0F172A;
  box-shadow: none;
}

.banner-content h1 {
  font-size: 1.5rem;
  font-weight: 800 !important;
  letter-spacing: -0.02em;
  margin-bottom: 4px;
  color: #C2460F;
}

.banner-content p {
  margin-bottom: 0;
  opacity: 1;
  font-size: 0.88rem;
  line-height: 1.35;
  color: #56647A;
}

/* ==========================================
   LEVÝ PANEL S KATEGORIEMI (SIDEBAR)
   ========================================== */
.category-sidebar {
  background: #ffffff;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
  border: 1px solid #e5e5e7;
}

.sidebar-title {
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #8e8e93;
  font-weight: 700;
  margin-bottom: 15px;
  padding-left: 10px;
}

.category-menu {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.category-link {
  display: flex;
  align-items: center;
  width: 100%;
  background: transparent;
  border: none;
  padding: 14px 16px;
  border-radius: 10px;
  cursor: pointer;
  text-align: left;
  transition: all 0.2s ease;
}

.category-icon {
  width: 32px;
  height: 32px;
  background: #f5f5f7;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 14px;
  color: #555555;
  transition: all 0.2s ease;
}

.category-icon i {
  font-size: 1rem;
}

.category-text {
  font-weight: 600;
  color: #3a3a3c;
  font-size: 0.98rem;
  flex-grow: 1;
}

.arrow-indicator {
  font-size: 0.75rem;
  color: #c7c7cc;
  transition: transform 0.2s ease;
}

.category-link:hover {
  background: #fafafa;
}

.category-link:hover .category-icon {
  background: #e5e5e7;
  color: #1a1a1a;
}

/* Aktivní oranžová kategorie v levém menu */
.category-link.active-category {
  background: rgba(255, 107, 53, 0.08);
}

.category-link.active-category .category-icon {
  background: #ff6b35;
  color: #ffffff;
}

.category-link.active-category .category-text {
  color: #ff6b35;
}

.category-link.active-category .arrow-indicator {
  color: #ff6b35;
  transform: translateX(3px);
}

/* ==========================================
   PRAVÝ PANEL S DOTAZY
   ========================================== */
.faq-content-card {
  border-radius: 16px;
  border: 1px solid #e5e5e7;
}

.current-category-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f0f0f2;
  padding-bottom: 15px;
}

.current-category-header h2 {
  font-size: 1.4rem;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0;
}

.badge-count {
  background: #f5f5f7;
  color: #666666;
  font-size: 0.85rem;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 20px;
}

/* ==========================================
   STYLOVÁNÍ PRIMEVUE ACCORDION (Harmonika)
   ========================================== */
.custom-accordion {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* Výchozí zavřená položka */
:deep(.custom-accordion .p-accordion-tab) {
  border-radius: 12px;
  overflow: hidden;
  background: transparent;
}

:deep(.custom-accordion .p-accordion-header .p-accordion-header-link) {
  background: #ffffff;
  border: 1px solid #e5e5e7;
  color: #2c2c2e;
  font-weight: 600;
  padding: 18px 24px;
  border-radius: 12px;
  transition: all 0.2s ease;
  flex-direction: row-reverse;
  justify-content: space-between;
}

/* Hover na zavřenou položku */
:deep(.custom-accordion .p-accordion-header:not(.p-highlight):hover .p-accordion-header-link) {
  border-color: #e5e5e7;
  color: #2c2c2e;
  background: #ffffff;
}

/* Otevřená karta: výplň na obalu, vnitřek bez vlastních rohů */
:deep(.custom-accordion .p-accordion-tab-active) {
  background: #f4f4f5;
}

:deep(.custom-accordion .p-accordion-tab-active .p-accordion-header-link) {
  background: transparent;
  border-color: #e5e5e7;
  color: #2c2c2e;
  border-radius: 0;
  border-bottom: 1px solid #e5e5e7 !important;
}

/* Nastavení ikony šipky */
:deep(.custom-accordion .p-accordion-toggle-icon) {
  color: #8e8e93;
  transition: transform 0.2s ease;
}

:deep(.custom-accordion .p-accordion-tab-active .p-accordion-toggle-icon) {
  color: #ff6b35;
}

/* Vnitřní obsah odpovědi */
:deep(.custom-accordion .p-accordion-content) {
  background: #ffffff !important;
  border: 1px solid #e5e5e7 !important;
  border-top: none !important;
  padding: 20px 24px 24px 24px;
  border-radius: 0;
  box-shadow: none !important;
}

:deep(.custom-accordion .p-accordion-tab-active .p-accordion-content),
:deep(.custom-accordion .p-accordion-tab-active .p-toggleable-content) {
  background: transparent !important;
  border-radius: 0 !important;
}

.faq-answer-wrapper {
  padding-top: 4px;
}

.faq-answer-text {
  color: #48484a;
  line-height: 1.6;
  margin: 0;
  font-size: 0.98rem;
}

/* Podpora pro HTML <b> tagy uvnitř textu z databáze */
.faq-answer-text :deep(b) {
  color: #ff6b35;
  font-weight: 700;
}

.img-inga-card {
  overflow: visible !important;
}

.inga-speech-bubble {
  position: absolute !important;
  top: -70px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  background-color: #ffffff !important;
  border: 2px solid #FF7A00 !important;
  color: #1E293B !important;
  font-weight: 700 !important;
  font-size: 0.82rem !important;
  padding: 10px 14px !important;
  border-radius: 16px !important;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.06) !important;
  z-index: 30 !important;
  width: 92% !important;
  max-width: 280px !important;
  line-height: 1.4 !important;
}

.inga-speech-bubble-dark {
  background-color: #1E293B !important;
  color: #E2E8F0 !important;
}

@media (min-width: 768px) {
  .inga-speech-bubble {
    top: -72px !important;
    padding: 12px 18px !important;
    font-size: 0.88rem !important;
    max-width: 320px !important;
  }
}

.inga-speech-bubble::after, .inga-speech-bubble::before {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  border-style: solid;
  display: block;
  width: 0;
}
.inga-speech-bubble::after { border-width: 10px 10px 0; border-color: #ffffff transparent transparent; z-index: 31; }
.inga-speech-bubble::before { bottom: -13px; border-width: 11px 11px 0; border-color: #FF7A00 transparent transparent; z-index: 29; }
.inga-speech-bubble-dark::after { border-color: #1E293B transparent transparent; }

/* ==========================================
   DARK MODE
   ========================================== */
.faq-page-dark .faq-hero-banner {
  background: #0F172A !important;
  border: 1px solid #334155 !important;
  box-shadow: none !important;
}

.faq-page-dark .banner-content p {
  color: #94A3B8;
  opacity: 1;
}

.faq-page-dark .category-sidebar {
  background: #0F172A !important;
  border: 1px solid #334155 !important;
  box-shadow: none;
}

.faq-page-dark .sidebar-title {
  color: #94A3B8;
}

.faq-page-dark .category-icon {
  background: #1E293B;
  color: #CBD5E1;
}

.faq-page-dark .category-text {
  color: #E2E8F0;
}

.faq-page-dark .arrow-indicator {
  color: #64748B;
}

.faq-page-dark .category-link:hover {
  background: #1E293B;
}

.faq-page-dark .category-link:hover .category-icon {
  background: #0F172A;
  color: #E2E8F0;
}

.faq-page-dark .category-link.active-category {
  background: rgba(255, 107, 53, 0.12);
}

.faq-page-dark .faq-content-card {
  background: #0F172A !important;
  border: 1px solid #334155 !important;
  border-radius: 0.65rem;
}

.faq-page-dark .current-category-header {
  border-bottom-color: #1E293B;
}

.faq-page-dark .current-category-header h2 {
  color: #E2E8F0;
}

.faq-page-dark .badge-count {
  background: #1E293B;
  color: #94A3B8;
}

.faq-page-dark :deep(.custom-accordion .p-accordion-header .p-accordion-header-link) {
  background: #1E293B !important;
  border: 1px solid #334155 !important;
  color: #E2E8F0 !important;
}

.faq-page-dark :deep(.custom-accordion .p-accordion-header:not(.p-highlight):hover .p-accordion-header-link) {
  border-color: #334155 !important;
  color: #E2E8F0 !important;
  background: #1E293B !important;
}

.faq-page-dark :deep(.custom-accordion .p-accordion-tab-active) {
  background: #2d3b4f !important;
}

.faq-page-dark :deep(.custom-accordion .p-accordion-tab-active .p-accordion-header-link) {
  background: transparent !important;
  border-color: #3d4f66 !important;
  color: #F1F5F9 !important;
  border-radius: 0 !important;
  border-bottom: 1px solid #3d4f66 !important;
}

.faq-page-dark :deep(.custom-accordion .p-accordion-toggle-icon) {
  color: #94A3B8;
}

.faq-page-dark :deep(.custom-accordion .p-accordion-content) {
  background: #1E293B !important;
  border: 1px solid #334155 !important;
  border-top: none !important;
}

.faq-page-dark :deep(.custom-accordion .p-accordion-tab-active .p-accordion-content),
.faq-page-dark :deep(.custom-accordion .p-accordion-tab-active .p-toggleable-content) {
  background: transparent !important;
  border-color: #3d4f66 !important;
  border-radius: 0 !important;
}

.faq-page-dark .faq-answer-text {
  color: #CBD5E1;
}

.faq-page-dark .faq-answer-text :deep(div),
.faq-page-dark .faq-answer-text :deep(p),
.faq-page-dark .faq-answer-text :deep(span),
.faq-page-dark .faq-answer-text :deep(li) {
  background: transparent !important;
  color: inherit !important;
}

.faq-page-dark :deep(.p-accordion-tab-active .p-accordion-content),
.faq-page-dark :deep(.p-accordion-tab-active .p-toggleable-content) {
  background: transparent !important;
  color: #E2E8F0 !important;
  border-color: #3d4f66 !important;
  border-radius: 0 !important;
}

.faq-page-dark .category-link:hover {
  background: #1E293B !important;
}
</style>

<style>
.faq-page-container .p-component.p-accordion .p-accordion-header:not(.p-disabled) .p-accordion-header-link:focus,
.faq-page-container .p-accordion .p-accordion-header:not(.p-disabled) .p-accordion-header-link:focus,
.faq-page-container .p-accordion .p-accordion-header-link:focus,
.faq-page-container .p-accordion .p-accordion-header-link:focus-visible,
.faq-page-container .p-accordion .p-accordion-header.p-highlight .p-accordion-header-link,
.faq-page-container .p-accordion-tab-active .p-accordion-header-link {
  box-shadow: none !important;
  outline: none !important;
}

.faq-page-container:not(.faq-page-dark) .p-accordion-tab-active {
  background: #f4f4f5 !important;
  overflow: hidden;
  border-radius: 12px;
}

.faq-page-container:not(.faq-page-dark) .p-accordion-tab-active .p-accordion-header-link,
.faq-page-container:not(.faq-page-dark) .p-accordion-tab-active .p-toggleable-content,
.faq-page-container:not(.faq-page-dark) .p-accordion-tab-active .p-accordion-content {
  background: transparent !important;
  background-color: transparent !important;
  border-radius: 0 !important;
}

.faq-page-container:not(.faq-page-dark) .p-accordion-tab-active .faq-answer-wrapper,
.faq-page-container:not(.faq-page-dark) .p-accordion-tab-active .faq-answer-text,
.faq-page-container:not(.faq-page-dark) .p-accordion-tab-active .faq-answer-text * {
  background: transparent !important;
  background-color: transparent !important;
}

.faq-page-container.faq-page-dark .p-accordion .p-accordion-header-link {
  background: #1E293B !important;
  color: #E2E8F0 !important;
  border-color: #334155 !important;
  box-shadow: none !important;
  outline: none !important;
}

.faq-page-container.faq-page-dark .p-accordion-tab-active {
  background: #2d3b4f !important;
  background-color: #2d3b4f !important;
  overflow: hidden;
  border-radius: 12px;
}

.faq-page-container.faq-page-dark .p-accordion-tab-active .p-accordion-header,
.faq-page-container.faq-page-dark .p-accordion-tab-active .p-accordion-header-link,
.faq-page-container.faq-page-dark .p-accordion-tab-active .p-toggleable-content,
.faq-page-container.faq-page-dark .p-accordion-tab-active .p-accordion-content {
  background: transparent !important;
  background-color: transparent !important;
  color: #E2E8F0 !important;
  border-color: #3d4f66 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}

.faq-page-container.faq-page-dark .p-accordion-tab-active .faq-answer-wrapper,
.faq-page-container.faq-page-dark .p-accordion-tab-active .faq-answer-text,
.faq-page-container.faq-page-dark .p-accordion-tab-active .faq-answer-text * {
  background: transparent !important;
  background-color: transparent !important;
  color: #CBD5E1 !important;
}

.faq-page-container.faq-page-dark .p-accordion-tab-active .faq-answer-text b,
.faq-page-container.faq-page-dark .p-accordion-tab-active .faq-answer-text strong {
  color: #FF8A4C !important;
}
</style>

